import { MarketContextProvider, useMarketContext } from '@/shared/context/MarketContext.tsx';
import { HttpClientContextProvider } from '@/shared/context/HttpClientContext.tsx';
import { MarketCodeSchema } from '@schuettflix/utils';
import { FulfillmentPage } from '@/modules/fulfillment/FulfillmentPage.tsx';
import { OrderLoader, OrderLoaderComponentProps } from '@/routes/loaders/OrderLoader.tsx';
import { useTranslation } from 'react-i18next';
import { MessageBox } from '@schuettflix/react-components';

function InnerFulfillmentRoute({ order }: OrderLoaderComponentProps) {
    const { t } = useTranslation();
    const { marketCode: contextMarketCode } = useMarketContext();
    const marketCode = order ? MarketCodeSchema.parse(order.marketCode) : contextMarketCode;

    if (!order) {
        return (
            <MessageBox type="error" title="Error">
                {t('fulfillment.error.noOrderId')}
            </MessageBox>
        );
    }

    if (order.status !== 'SUBMITTED') {
        return (
            <MessageBox type="error" title="Error">
                {`Cannot access order with status: ${order.status} in fulfillment`}
            </MessageBox>
        );
    }

    return (
        <MarketContextProvider marketCode={marketCode}>
            <HttpClientContextProvider marketCode={marketCode}>
                <FulfillmentPage order={order} />
            </HttpClientContextProvider>
        </MarketContextProvider>
    );
}

export const FulfillmentRoute = OrderLoader(InnerFulfillmentRoute);
